import { styled } from 'styled-components';

// Just an empty wrapper around react-datepicker
export const Wrapper = styled.div`
  width: 100%;
`;
